module.exports = __webpack_public_path__ + "img/icon-game-5426.e7062fc3.png";